import React from "react";
import { GALLERY } from "../lib/data";
import SectionNumber from "./SectionNumber";

const LABELS = [
  "Szabadtűz",
  "Kemence",
  "Vendégház",
  "Tematikus est",
  "Tisza-part",
  "Állatok",
  "Workshop",
  "Közösség",
];

export default function Gallery() {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative bg-white py-24 sm:py-32 overflow-hidden"
    >
      <SectionNumber n="08" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-8 mb-12 items-end">
          <div className="md:col-span-7 reveal">
            <span className="eyebrow">Galéria</span>
            <h2 className="font-serif text-pkcharcoal text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
              Pillanatok<br />
              <span className="italic text-pkred">a tűz mellől.</span>
            </h2>
          </div>
          <div className="md:col-span-5 reveal">
            <p className="text-pkcharcoal/70 text-base sm:text-lg leading-relaxed">
              Képek a Pakkaland mindennapjaiból – tűz, étel, vendégek,
              kemence, állatok, vendégház és természet.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[240px]">
          {GALLERY.map((src, i) => (
            <div
              key={src}
              data-testid={`gallery-item-${i}`}
              className={`gallery-item reveal ${
                i === 0 || i === 3 ? "row-span-2" : ""
              }`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <img
                src={src}
                alt={LABELS[i]}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="gallery-overlay">
                <div>
                  <div className="w-6 h-px bg-white/80 mb-2" />
                  <div className="text-white font-serif text-lg">
                    {LABELS[i]}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
